import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector } from '@angular/core';

import { LoggerService } from '../logger/logger.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: Error | HttpErrorResponse) {
    const loggingService = this.injector.get(LoggerService);

    let message: string;
    let stackTrace: string;

    if (error instanceof HttpErrorResponse) {
      // Server error
      message = `Error Code: ${error.status}\nMessage: ${error.message}`;
      stackTrace = error.error.stack;
    } else {
      // Client Error
      message = error.message;
      stackTrace = error.stack || '';
    }

    loggingService.error(message, stackTrace);
  }
}
